export default __webpack_public_path__ + "static/media/fail.86b1714e.png";